import { theme } from "uikit";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns) => {
	if (!item || !dateFns) {
		return {
			content: "",
			backgroundColor: undefined,
			textColor: undefined,
		};
	}

	const isPreliminary =
		item.isPreliminary ||
		item?.additionalFields?.transfer?.lastReceivedOrder?.isPreliminary;

	const content = isPreliminary
		? dateFns.formatTime2(item.orderDate, "dd-MM-yyyy")
		: "";

	return {
		content,
		backgroundColor: isPreliminary ? "#7B0078" : undefined,
		textColor: isPreliminary ? theme.colors.white : undefined,
	};
};
export default cellProcessing;
